import { render, staticRenderFns } from "./ComponentMainDialog.vue?vue&type=template&id=05080c47&scoped=true&"
import script from "./ComponentMainDialog.vue?vue&type=script&lang=js&"
export * from "./ComponentMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05080c47",
  null
  
)

export default component.exports